import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import CoeTable from './CoeTable';
import COEModal from './COEModal';
import { disableCOE, getAllCOE } from '../../../services/adminServices/CoeServices';
import { toast } from 'react-toastify';

const COE = () => {
  const [openModal, setOpenModal] = useState({ userForm: false });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editRowData, setEditRowData] = useState(null);
  const [user, setUser] = useState("")

  const handleModalToggle = (modalName, data = null) => {
    setOpenModal((prev) => ({ [modalName]: !prev[modalName] }));
    if (!data) {
      setEditRowData(null);
    } else {
      setEditRowData(data);
    }
  };
  const handleEditClick = (data) => {
    handleModalToggle('userForm', data);
  };

  const handleSuccessfulCOECreation = () => {
    setOpenModal(false);
  };
  const fetchData = async () => {
    try {
      const coes = await getAllCOE();
      setRows(coes?.data?.data);
    } catch (error) {
      setError('Error fetching COEs');
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"))
    setUser(user)
    fetchData();
  }, []);
  const disableCoe = async (id) => {
    try {
      const response = await disableCOE(id);
      toast.success(response.data.message);
      fetchData();
    } catch (error) {
      toast.error( error?.response?.data.message||error?.message ||error?.error);
    }
  }
  return (
    <Box className="dashboard-container">
      <Box className="dashboard-header">
        <Typography className="dashboard-header-title">Welcome {user?.name}</Typography>
        {user?.role === 'super_admin' && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleModalToggle('userForm')}
          className="dashboard-header-button"
        >
          CREATE COE
        </Button>)}
        <COEModal
          open={openModal.userForm}
          onClose={() => handleModalToggle('userForm')}
          fetchData={fetchData}
          rowData={editRowData}
          onSuccess={handleSuccessfulCOECreation}
        />
      </Box>
      <Box className="dashboard-box-container">
        <CoeTable rows={rows} loading={loading} error={error} onEditClick={handleEditClick} disableCoe={disableCoe} fetchCoeData={fetchData} user={user} />
      </Box>
    </Box>
  );
};

export default COE;
